import css from 'styled-jsx/css';

export default css`:global(.slick-prev::before, .slick-next::before) {
  color: #ffffff;
  opacity: 1; }

:global(.slick-dots li button:before) {
  color: #cccccc;
  opacity: 1; }

:global(.slick-dots li.slick-active button:before) {
  color: #ffffff; }

h2 {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.42;
  letter-spacing: 0.4px;
  text-align: center;
  color: #414141;
  margin-bottom: 64px;
  position: relative;
  margin-top: 160px; }

h2:after {
  content: '';
  display: block;
  width: 48px;
  height: 8px;
  background-color: #414141;
  border-radius: 4px;
  position: absolute;
  left: 50%;
  top: 50px;
  transform: translateX(-50%); }

.creators {
  position: relative;
  height: 400px;
  transition: 2s; }
  .creators .slick {
    height: 30px; }
  .creators :global(.slick.slick-slider) {
    width: 1000px;
    margin: auto; }
    @media only screen and (max-width: 500px) {
      .creators :global(.slick.slick-slider) {
        width: 100vw;
        height: 300px; } }
    .creators :global(.slick.slick-slider) .box {
      height: 285px; }
      @media only screen and (max-width: 500px) {
        .creators :global(.slick.slick-slider) .box {
          width: 246px !important; } }
      .creators :global(.slick.slick-slider) .box .wrap {
        background-color: #fff;
        height: 100%;
        width: 90%;
        margin: auto;
        overflow: hidden;
        border-radius: 8px;
        padding-top: 10px; }
        .creators :global(.slick.slick-slider) .box .wrap :hover {
          opacity: 0.7;
          transform: scale(0.95); }
        .creators :global(.slick.slick-slider) .box .wrap img {
          margin: auto;
          width: 209px;
          height: 209px;
          border-radius: 8px 8px 0 0; }
        .creators :global(.slick.slick-slider) .box .wrap .name {
          color: #414141;
          text-align: center;
          font-size: 16px;
          margin-top: 11px; }
        .creators :global(.slick.slick-slider) .box .wrap .script {
          color: #999999;
          text-align: center;
          font-size: 12px;
          margin-top: 15px; }
`